// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MxME","largestCol":"styles_largestCol__2sxIS","smallestCol":"styles_smallestCol__3cjBn"};